import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, MessageService, PrimeTemplate } from "primeng/api";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import {
  PARAM_CATEGORIES_PATH,
  PARAM_CLIENTS_PATH,
  PARAM_REQUESTS_PATH,
} from "src/app/constants/constants";
import { Clients } from "src/app/models/clients";
import { ClientsService } from "src/app/services/clients.service";
import { Requests } from "src/app/models/requests";
import { RequestsService } from "src/app/services/requets.service";
import { Rooms } from "src/app/models/rooms";
import { RoomsService } from "src/app/services/rooms.service";
import { BookingsService } from "src/app/services/bookings.service";
import { Bookings } from "src/app/models/bookings";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";
import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { ButtonDirective } from "primeng/button";
import { TopNavComponent } from "../../top-nav/top-nav.component";
import { CurrencyPipe } from "@angular/common";
import { TableModule } from "primeng/table";
import { Tag } from "primeng/tag";
import { NgxPaginationModule } from "ngx-pagination";
import { Card } from "primeng/card";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";

import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-manage-requests",
    templateUrl: "./manage-requests.component.html",
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, ButtonDirective, TopNavComponent, TableModule, Tag, RouterLink, NgxPaginationModule, Card, ConfirmDialog, Toast, CurrencyPipe]
})
export class ManageRequestsComponent extends AbstractListController<
  Bookings,
  any
> {
  protected requestsService = inject(RequestsService);
  protected confirmationService: ConfirmationService;
  private roomsService = inject(RoomsService);
  private messageService = inject(MessageService);
  private bookingsService: BookingsService;

  title = "Richieste";
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  readonly request = signal<Requests>(undefined);
  readonly roomDialog = signal<boolean>(false);
  readonly requestRoom = signal<Rooms>(undefined);

  constructor() {
    const confirmationService = inject(ConfirmationService);
    const bookingsService = inject(BookingsService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      bookingsService,
      confirmationService,
      router,
      route,
      PARAM_REQUESTS_PATH
    );
    this.confirmationService = confirmationService;
    this.bookingsService = bookingsService;

    this.cols.set([
      { field: "name", header: "Nome" },
      { field: "address", header: "Indirizzo" },

      { field: "phone", header: "Telefono" },
      { field: "email", header: "Email" },
      { field: "created_at", header: "Data" },
    ]);
    this.colsFilter.set([
      { field: "name", icon: "pi-user", header: "Nome", type: "string" },
      { field: "email", icon: "pi-envelope", header: "Email", type: "string" },
      { field: "phone", icon: "pi-phone", header: "Telefono", type: "string" },
    ]);


    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({
        label: this.cols()[i].header,
        value: this.cols()[i],
      }); return [...a]; });
    }
  }

  edit(request: Requests) {
    this.request.set({ ...request });

    if (this.request().ref_id !== "0") {
      this.roomsService.getId(this.request().ref_id).subscribe((res) => {
        this.requestRoom.set(res);
      });
    }
    this.roomDialog.set(true);
  }



  close(request: Requests) {
    const formData = new FormData();

    formData.set("status", "0");
    this.requestsService.update(formData, request.id).subscribe(
      (res) => {
        this.load();
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Attenzione",
          detail: "Aggiornato con success",
        });
      },
      (error) => (this.error.set(error))
    );
  }

  open(request: Requests) {
    const formData = new FormData();

    formData.set("status", "1");

    this.requestsService.update(formData, request.id).subscribe(
      (res) => {
        this.load();
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Attenzione",
          detail: "Aggiornato con success",
        });
      },
      (error) => (this.error.set(error))
    );
  }


}
